<div class="card">
  <div class="card-header">
    <div class="card-body">
      <label>Select Date Range (default - 1 day)</label>
      <div class="d-flex flex-wrap align-items-start gap-3 mt-4">
        <div class="form-group d-flex flex-column me-3" style="min-width: 220px; position: relative;"
          #fromPickerWrapper>
          <label class="col-form-label">Date From</label>
          <input class="form-control" readonly [value]="fromDisplay" (click)="toggleFromPicker()"
            placeholder="yyyy-mm-dd" />
          <div class="card shadow position-absolute mt-1 p-3" *ngIf="fromPickerOpen"
            style="z-index: 999; width: 320px;">
            <ngb-datepicker [(ngModel)]="searchFromDate" [maxDate]="maxDateFrom">
            </ngb-datepicker>
            <div class="text-end mt-3">
              <button type="button" class="btn btn-sm btn-secondary me-2" (click)="closeFromPicker()">
                Cancel
              </button>
              <button type="button" class="btn btn-sm btn-primary" (click)="applyFrom()">
                Apply
              </button>
            </div>
          </div>
        </div>
        <div class="form-group d-flex flex-column me-3" style="min-width: 220px; position: relative;" #toPickerWrapper>
          <label class="col-form-label">Date To</label>
          <input class="form-control" readonly [value]="toDisplay" (click)="toggleToPicker()"
            placeholder="yyyy-mm-dd" />
          <div class="card shadow position-absolute mt-1 p-3" *ngIf="toPickerOpen" style="z-index: 999; width: 320px;">
            <ngb-datepicker [(ngModel)]="searchToDate" [minDate]="minDate" [maxDate]="maxDate">
            </ngb-datepicker>
            <div class="text-end mt-3">
              <button type="button" class="btn btn-sm btn-secondary me-2" (click)="closeToPicker()">Cancel</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="applyTo()">Apply</button>
            </div>
          </div>
        </div>
        <div class="form-group me-3" style="min-width: 200px;">
          <label>Merchant List</label>
          <ng-select [items]="merchantListdata" bindLabel="FieldText" bindValue="FieldValue" [(ngModel)]="merchantList"
            placeholder="Select Merchant" [searchable]="true" [clearable]="true">
          </ng-select>
        </div>
        <div class="form-group me-3" style="min-width: 200px;">
          <label>Currency From</label>
          <ng-select [items]="currencyFromList" bindLabel="FieldText" bindValue="FieldValue" [(ngModel)]="currencyFrom"
            (ngModelChange)="onCurrencyFromChange($event)" placeholder="Select Currency From">
          </ng-select>
        </div>
        <div class="form-group me-3" style="min-width: 200px;">
          <label>Currency To</label>
          <ng-select [items]="currencyToList" bindLabel="FieldText" bindValue="FieldValue" [(ngModel)]="currencyTo"
            (ngModelChange)="onCurrencyToChange($event)" placeholder="Select Currency To">
          </ng-select>
        </div>
        <div class="form-group me-3" style="min-width: 200px;">
          <label>Status</label>
          <ng-select [items]="merchantStatusdata" bindLabel="FieldText" bindValue="FieldValue" [(ngModel)]="status"
            placeholder="Select Status">
          </ng-select>
        </div>
      </div>
      <div class="text-start">
        <!-- <button type="button" class="btn bg-danger-custom" (click)="isQuickFilter=!isQuickFilter">
         Quick Filterss <i class="feather icon-filter"></i>
    </button> -->
        <button type="button" class="btn bg-danger-custom" (click)="onSearchFilter()">Search<i
            class="feather icon-search"></i></button>
        <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">Export Excel<i
      class="feather icon-download"></i></button>
        <!-- <button type="button" class="btn bg-danger-custom" (click)="onBackgroundExport()">Export All<i class="feather icon-download-cloud"></i></button> -->
        <div class="btn-group" ngbDropdown role="group">
          <button class="btn bg-danger-custom" ngbDropdownToggle>Columns</button>
          <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
            style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
            <div class="form-group">
              <!--            <label for="columns" class="form-label"> All Columns</label>-->
              <div *ngIf="columnDefs" class="list-group ng-option">
                <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                  <label class="list-group-item p-2">
                    <input type="checkbox" class="form-check-input me-1" style="margin-left: 180px;" [value]="i"
                      [checked]="!column.hide" (change)="updateSelectedColumn($event)" />
                    {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') )
                    }}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="min-height: 300px">
      <div class="col-12 col-xl-12">
        <div style="width: 100%; min-height: 520px;">
          <!-- <ag-grid-angular class="ag-theme-alpine" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
            [rowData]="rowData" [pinnedBottomRowData]="pinnedBottomRowData" [pagination]="true"
            [paginationPageSize]="pageSize" [suppressPaginationPanel]="true" [rowSelection]="'single'"
            (gridReady)="onGridReady($event)" (filterModified)="onFilterModified($event)"
            [enableCellTextSelection]="true" [ensureDomOrder]="true" style="width: 100%; height: 500px;">
          </ag-grid-angular> -->
          <!-- <ag-grid-angular
            class="ag-theme-alpine"
            [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef"
            [rowData]="rowData"
            [pagination]="true"
            [paginationPageSize]="pageSize"
            [suppressPaginationPanel]="true"
            (gridReady)="onGridReady($event)"
            (cellClicked)="onCellClicked($event)"

            [isFullWidthRow]="isFullWidthRow"
            [fullWidthCellRenderer]="fullWidthCellRenderer"
            [fullWidthCellRendererParams]="{}"
            [getRowHeight]="getRowHeight"
            style="width: 100%; height: 500px;">
          </ag-grid-angular> -->
          <ag-grid-angular
            class="ag-theme-alpine"
            [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef"
            [rowData]="rowData"
            (gridReady)="onGridReady($event)"
            (cellClicked)="onCellClicked($event)"
            [isFullWidthRow]="isFullWidthRow"
            [fullWidthCellRenderer]="fullWidthCellRenderer"
            [getRowHeight]="getRowHeight"
            style="width:100%; height:500px;">
          </ag-grid-angular>
        </div>
      </div>
    </div>

    <!-- Pagination Section -->
    <div class="row bg-white p-2 mt-0">
      <div class="col-4 col-xs-4 d-flex">
        <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="30">30</option>
          <option [ngValue]="40">40</option>
          <option [ngValue]="50">50</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>
      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
          class="d-flex justify-content-end col-8 align-right">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>